var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-device-list animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "b-card",
              [
                _c("h1", { staticClass: "lbv-page-title" }, [
                  _vm._v("\n          Device List\n        "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row secondary device-list-filters" },
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Order by", "label-cols": 4 } },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.sortOptions, value: "" },
                              on: { input: _vm.fetchUserData },
                              model: {
                                value: _vm.sortOption,
                                callback: function ($$v) {
                                  _vm.sortOption = $$v
                                },
                                expression: "sortOption",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Filter by", "label-cols": 3 } },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.filterOptions },
                              on: { input: _vm.fetchUserData },
                              model: {
                                value: _vm.filterOption,
                                callback: function ($$v) {
                                  _vm.filterOption = $$v
                                },
                                expression: "filterOption",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "Rows per page", "label-cols": 6 },
                          },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.pageOptions },
                              on: { input: _vm.fetchUserData },
                              model: {
                                value: _vm.perPage,
                                callback: function ($$v) {
                                  _vm.perPage = $$v
                                },
                                expression: "perPage",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    responsive: "",
                    striped: "",
                    hover: "",
                    items: _vm.deviceList,
                    fields: _vm.fields,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "leakbotId",
                      fn: function (data) {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "deviceLink",
                              attrs: {
                                to: {
                                  name: "DeviceView",
                                  params: { deviceID: data.value },
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.value) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page prev",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: _vm.currentPage === 1,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Prev\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page next",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: !_vm.hasNextPage,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Next\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "current-page" }, [
                  _vm._v(
                    "\n          Page: " +
                      _vm._s(_vm.currentPage) +
                      "\n        "
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }